import React, { useRef, useState } from 'react'
import moment from 'moment'
import { ClickAwayListener, Grow, Paper, Popper, MenuList, MenuItem, Button, makeStyles } from '@material-ui/core'
import DateFilters from './DateFilters'

const getDateByFilter = filter => {
  let start, stop
  const FMT = 'YYYY-MM-DD'
  switch (filter) {
    case 'yesterday':
      start = moment().subtract(1, 'day').startOf('day')
      stop = moment(start.format(FMT), FMT).endOf('day')
      break

    case 'today':
      start = moment().startOf('day')
      stop = moment(start.format(FMT), FMT).endOf('day')
      break

    case 'tomorrow':
      start = moment().add(1, 'day').startOf('day')
      stop = moment(start.format(FMT), FMT).endOf('day')
      break

    case 'last-week':
      start = moment().subtract(1, 'week').startOf('week')
      stop = moment(start.format(FMT), FMT).endOf('week')
      break

    case 'this-week':
      start = moment().startOf('week')
      stop = moment(start.format(FMT), FMT).endOf('week')
      break

    case 'next-week':
      start = moment().add(1, 'week').startOf('week')
      stop = moment(start.format(FMT), FMT).endOf('week')
      break

    case 'last-month':
      start = moment().subtract(1, 'month').startOf('month')
      stop = moment(start.format(FMT), FMT).endOf('month')
      break

    case 'this-month':
      start = moment().startOf('month')
      stop = moment(start.format(FMT), FMT).endOf('month')
      break

    case 'next-month':
      start = moment().add(1, 'month').startOf('month')
      stop = moment(start.format(FMT), FMT).endOf('month')
      break
  }
  return { start, stop }
}

const useStyles = makeStyles(theme => ({
  quickFilterGroup: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  quickFilterGroupButton: {
    margin: '0.2em 0.2rem',
    fontSize: '13px',
    backgroundColor: '#bdbdcc',
    width: '30%',
    border: '1px solid #aeaeae',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'rgb(244, 244, 244)',
    }
  },
  quickFilterSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '5px'
  },
  quickFilterContainer: {
    padding: '0.5em',
    marginTop: '5px',
    paddingBottom: '1px',
    '& .input-group': {
      marginBottom: '1em',
      display: 'inline-flex',
      '& .input-group-addon': {
        width: '6ch'
      },
      '& input': {
        width: '13ch',
        marginRight: '1em'
      }
    }
  }
}))

const QuickFilters = (props) => {
  const [showMenu, setShowMenu] = useState(false)
  const buttonRef = useRef()

  const classes = useStyles()

  function applyFilter(filter, e) {
    if (e) e.preventDefault()
    setShowMenu(false)

    const { start, stop } = getDateByFilter(filter)

    props.onChange({
      startDateTime: start,
      stopDateTime: stop,
    })
  }

  return (
    <div
      className='quick-filter-select'
      style={props.isTop ? { zIndex: 4 } : { zIndex: 1 }}
    >
      <ClickAwayListener onClickAway={() => setShowMenu(false)}>
        <div style={{ width: 'min-content' }}>
          <button
            ref={buttonRef}
            disabled={props.disabled}
            type='button'
            className='btn btn-default'
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
            onClick={() => setShowMenu(true)}
          >
            Date Range <span className='caret'></span>
          </button>
          <Popper
            open={showMenu}
            anchorEl={buttonRef.current}
            transition
            disablePortal={true}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center-top' : 'center-bottom',
                }}
              >
                <Paper>
                  <div>
                    <div className={classes.quickFilterContainer}>
                      <GroupButtons
                        classes={classes}
                        onClick={applyFilter}
                        disabled={props.disabled}
                      />
                      <DateFilters
                        onChange={(ev) => {
                          props.onChange(ev)
                          setShowMenu(false)
                        }}
                        filters={props.filters}
                        disabled={props.disabled}
                      />
                    </div>
                  </div>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </ClickAwayListener>
    </div>
  )
}

const GroupButtons = props => { 
  const { classes, onClick, disabled } = props
  return <div className={classes.quickFilterSectionContainer}>
    <div className={classes.quickFilterGroup}>
      <Button disabled={disabled} className={classes.quickFilterGroupButton} onClick={onClick.bind(null, 'yesterday')} >Yesterday</Button>
      <Button disabled={disabled} className={classes.quickFilterGroupButton} onClick={onClick.bind(null, 'today')} >Today</Button>
      <Button disabled={disabled} className={classes.quickFilterGroupButton} onClick={onClick.bind(null, 'tomorrow')} >Tomorrow</Button>
    </div>
    
    <div className={classes.quickFilterGroup}>
      <Button disabled={disabled} className={classes.quickFilterGroupButton} onClick={onClick.bind(null, 'last-week')} >Last Week</Button>
      <Button disabled={disabled} className={classes.quickFilterGroupButton} onClick={onClick.bind(null, 'this-week')} >This Week</Button> 
      <Button disabled={disabled} className={classes.quickFilterGroupButton} onClick={onClick.bind(null, 'next-week')} >Next Week</Button>
    </div>
    
    <div className={classes.quickFilterGroup}>
      <Button disabled={disabled} className={classes.quickFilterGroupButton} onClick={onClick.bind(null, 'last-month')} >Last Month</Button>
      <Button disabled={disabled} className={classes.quickFilterGroupButton} onClick={onClick.bind(null, 'this-month')} >This Month</Button>
      <Button disabled={disabled} className={classes.quickFilterGroupButton} onClick={onClick.bind(null, 'next-month')} >Next Month</Button>
    </div>
  </div>
}

export default QuickFilters
